<template>
  <div class="page text_center" v-loading="loading">
    <h1>NETCLASS英语作文智能批改系统（教师端）</h1>
    <div class="flex space_around">
      <p>
        学校：{{ classInfo.sys_school_name }}
        <span style="padding-left: 20px"
          >班级：{{ classInfo.sys_class_name }}</span
        >
      </p>
      <p>
        教师：{{ info.mem_name }}
        <span style="padding-left: 20px">编号：{{ info.mem_phone }}</span>
      </p>
    </div>
    <hr />
    <br />
    <div class="text_right">
      <el-button type="primary" @click="create">发布作业</el-button>
    </div>
    <br />

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        'text-align': 'center',
        background: '',
      }"
    >
      <el-table-column type="index" label="NO" align="center" />
      <el-table-column
        prop="title"
        label="题目"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="created_at"
        label="发布日期"
        align="center"
        width="200"
      />
      <el-table-column prop="status" label="分类" align="center" width="120">
        <template #default="scope">
          <el-link type="warning" v-if="scope.row.type == 0">通用</el-link>
          <el-link type="primary" v-if="scope.row.type == 1">雅思</el-link>
          <el-link type="success" v-if="scope.row.type == 2">托福</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="nums" label="人数" align="center" width="120" />

      <el-table-column
        prop="status"
        label="提交 - 未提交"
        align="center"
        width="120"
      >
        <template #default="scope">
          <el-link
            v-if="scope.row.cnums != 0"
            type="success"
            @click="getWork(scope.row, 1)"
            >{{ scope.row.cnums }}</el-link
          >
          <span v-else>0</span>
          -
          <el-link
            v-if="scope.row.nums - scope.row.cnums != 0"
            type="danger"
            @click="getWork(scope.row, 0)"
            >{{ scope.row.nums - scope.row.cnums }}</el-link
          >
          <span v-else>0</span>
        </template>
      </el-table-column>
    </el-table>

    <Pagination @pageChange="pageChangeFn" :total="total"></Pagination>
    <el-dialog v-model="dialogShow" title="发布作业" width="60%">
      <p class="text_center">
        <el-icon style="margin-top: 0"><WarningFilled /></el-icon
        >老师可以直接输入、粘贴相关作文题目，也可以在右侧的辅助资料栏里选择自己中意的作文题目。
      </p>
      <br />
      <el-row gutter="20">
        <el-col :span="14">
          <el-form ref="formRef" :model="form" label-width="130px">
            <el-form-item
              label="填入作文题目"
              prop="title"
              :rules="[
                {
                  required: true,
                  message: '请输入作文题目',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                :rows="8"
                v-model="form.title"
                placeholder="请输入作文题目"
              />
            </el-form-item>
            <br />
            <el-form-item label="任务说明" prop="remark">
              <el-input
                type="textarea"
                :rows="2"
                v-model="form.remark"
                placeholder="请输入任务说明（可选填）"
              />
            </el-form-item>
            <br />
            <el-form-item
              label="类型"
              prop="type"
              :rules="[
                {
                  required: true,
                  message: '请选择类型',
                  trigger: 'blur',
                },
              ]"
            >
              <el-radio-group v-model="form.type">
                <el-radio :label="1">雅思</el-radio>
                <el-radio :label="2">托福</el-radio>
                <el-radio :label="0">通用</el-radio>
              </el-radio-group>
            </el-form-item>
            <br />
            <el-form-item label="">
              <el-radio-group v-model="radio">
                <el-radio :label="1">布置给个人</el-radio>
                <el-radio :label="2">布置给全班</el-radio>
              </el-radio-group>
            </el-form-item>
            <br />
            <el-form-item v-if="radio == 1" label="选择姓名" prop="obj_id">
              <el-select
                v-model="form.obj_id"
                placeholder="请选择姓名"
                size="large"
              >
                <el-option
                  v-for="item in options"
                  :key="item.mem_id"
                  :label="item.relation_users.mem_name"
                  :value="item.mem_id"
                />
                <el-pagination
                  @current-change="handleCurrent"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="totalnum"
                >
                </el-pagination>
              </el-select>
            </el-form-item>
            <br />
            <br />
            <el-form-item>
              <el-button
                type="primary"
                @click="onSubmit(formRef)"
                :loading="btn_loading"
              >
                发 布
              </el-button>
            </el-form-item>
          </el-form></el-col
        >
        <el-col :span="10">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="雅思写作题" name="1">
              <div v-for="(item, index) in yasi" :key="index" class="text_left">
                <el-row>
                  <el-col :span="2" @click="handleSelect(item, index)">
                    <el-icon v-if="y_index === index"><CircleCheck /></el-icon>
                    <div class="circle" v-else></div>
                  </el-col>
                  <el-col :span="22">
                    <el-card class="card">
                      <div>{{ index + 1 }}</div>
                      <div>{{ item.题目 }}</div>
                      <el-divider />
                      <div>{{ item.备注 }}</div>
                    </el-card></el-col
                  >
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="托福写作题" name="2">
              <div
                v-for="(item, index) in tuofu"
                :key="index"
                class="text_left"
              >
                <el-row>
                  <el-col :span="2" @click="handleSelect_t(item, index)">
                    <el-icon v-if="t_index === index"><CircleCheck /></el-icon>
                    <div class="circle" v-else></div>
                  </el-col>
                  <el-col :span="22">
                    <el-card class="card">
                      <div>{{ index + 1 }}</div>
                      <div>{{ item.题目 }}</div>
                      <el-divider /> </el-card
                  ></el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="通用" name="0">
              <div
                v-for="(item, index) in tongyon"
                :key="index"
                class="text_left"
              >
                <el-row>
                  <el-col :span="2" @click="handleSelect_ty(item, index)">
                    <el-icon v-if="ty_index === index"><CircleCheck /></el-icon>
                    <div class="circle" v-else></div>
                  </el-col>
                  <el-col :span="22">
                    <el-card class="card">
                      <div>{{ index + 1 }}</div>
                      <div>{{ item.题目 }}</div>
                      <el-divider /> </el-card
                  ></el-col>
                </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>
          <br />
          <!-- <el-button type="primary">选择题目</el-button> -->
        </el-col>
      </el-row>
      <template #footer>
        <span class="dialog-footer"> </span>
      </template>
    </el-dialog>
    <el-dialog v-model="workShow" title="" width="30%">
      <div v-loading="d_loading">
        <el-table
          :data="workData"
          style="width: 100%"
          :header-cell-style="{
            'text-align': 'center',
            background: '',
          }"
        >
          <el-table-column type="index" label="NO" align="center" />
          <el-table-column
            prop="users[0].mem_name"
            label="学生姓名"
            align="center"
          />
          <el-table-column prop="" label="详情" align="center">
            <template #default="scope">
              <el-link type="primary" @click="getWorkInfo(scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog v-model="reportShow" title="" width="60%">
      <div v-loading="report_loading">
        <Report :reportData="reportData"></Report>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { reactive, ref, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '../../components/Pagination'
import { getList, handleAdd, getJob } from '../../request/jobList'
import { getUserList, getInfo } from '../../request/studentList'
import yasi from '../../assets/utils/yasi'
import tuofu from '../../assets/utils/tuofu'
import Report from '../../components/Report'
import tongyon from '../../assets/utils/tongyon'
export default {
  components: { Pagination, Report },
  setup() {
    const formRef = ref()
    const router = useRouter()
    const state = reactive({
      yasi,
      tuofu,
      tongyon,
      dialogShow: false,
      workShow: false,
      form: {},
      loading: false,
      tableData: [],
      total: 0,
      options: [],
      search: { page: 1 },
      user: { page: 1 },
      info: {},
      classInfo: {},
      radio: '',
      radio_yasi: 0,
      radio_tuofu: 0,
      activeName: '1',
      y_index: '',
      t_index: '',
      ty_index: '',
      workData: [],
      d_loading: false,
      totalnum: 0,
      reportShow: false,
      report_loading: false,
      reportData: {},
    })
    onMounted(() => {
      state.info = JSON.parse(localStorage.getItem('teacher'))
      state.classInfo = JSON.parse(localStorage.getItem('class'))
      init()
    })

    const init = async () => {
      state.loading = true
      state.search.class_id = state.classInfo.sys_class_id
      state.search.uid = state.info.mem_id
      const { data, code, msg, total } = await getList(state.search)
      state.loading = false
      if (code == 200) {
        state.tableData = data
        state.total = total
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const getUser = async () => {
      state.loading = true
      state.user.class_id = state.classInfo.sys_class_id
      console.log(state.user)
      const { data, code, msg, total } = await getUserList(state.user)
      state.loading = false
      if (code == 200) {
        state.options = data
        state.totalnum = total
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const onSearch = () => {
      state.search.page = 1
      init()
    }

    const pageChangeFn = value => {
      state.search.page = value
      init()
    }
    const create = () => {
      state.dialogShow = true
      state.form = {}
      state.y_index = ''
      state.t_index = ''
      state.ty_index = ''
      getUser()
    }
    const onSubmit = async (a, b) => {
      if (!formRef) return
      formRef.value.validate(valid => {
        if (valid) {
          state.btn_loading = true
          confirm()
        }
      })
    }
    const confirm = async () => {
      if ((state.radio == 1 && !state.form.obj_id) || !state.radio) {
        ElMessage.error('请选择学生')
        return
      }
      if (state.radio == 2) {
        state.obj_id = ''
      }
      const { data, code, msg } = await handleAdd(state.form)
      state.btn_loading = false
      if (code == 200) {
        ElMessage.success(msg)
        state.dialogShow = false
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const handleSelect = (e, index) => {
      state.form.title = e['题目']
      state.y_index = index
      state.t_index = ''
      state.ty_index = ''
      state.form.type = Number(state.activeName)
    }
    const handleSelect_t = (e, index) => {
      state.form.title = e['题目']
      state.y_index = ''
      state.ty_index = ''
      state.t_index = index
      state.form.type = Number(state.activeName)
    }
    const handleSelect_ty = (e, index) => {
      state.form.title = e['题目']
      state.y_index = ''
      state.t_index = ''
      state.ty_index = index
      state.form.type = Number(state.activeName)
    }
    const getWorkInfo = async row => {
      state.reportShow = true
      state.report_loading = true
      const { data, code, msg, total } = await getInfo({
        job_id: row.job_id,
        mem_id: row.mem_id,
      })
      state.report_loading = false
      if (code == 200) {
        state.reportData = data
        state.reportData.score = JSON.parse(data.score)
        state.reportData.check = JSON.parse(data.check)
        state.reportData.optimize = data.optimize
          ? JSON.parse(data.optimize)
          : []
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const getWork = async (e, status) => {
      console.log(e)
      state.workShow = true
      state.d_loading = true
      let postData = {
        status: status,
        id: e.id,
      }
      const { data, code, msg, total } = await getJob(postData)
      state.d_loading = false
      if (code == 200) {
        state.workData = data
        // state.total = total
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const handleCurrent = value => {
      state.page = value
      getUser()
    }

    return {
      ...toRefs(state),
      formRef,
      init,
      onSearch,
      onSubmit,
      create,
      pageChangeFn,
      handleSelect,
      handleSelect_t,
      getWork,
      handleCurrent,
      getWorkInfo,
      handleSelect_ty,
    }
  },
}
</script>

<style lang="less" scoped>
h1 {
  color: #409eff;
  font-size: 26px;
}
hr {
  background-color: #409eff;
  height: 1px;
  border: none;
}
.el-divider {
  margin: 0;
}
.index {
  background: #e6f2ff;
  color: #409eff;
  font-weight: 700;
  padding: 8px;
}
/deep/.card > .el-card__body {
  padding: 0 !important;
}
.card {
  margin: 5px;
}
.card div {
  padding: 10px;
}
.card div:nth-child(1) {
  background-color: #e6f2ff;
  font-weight: 700;
  color: #409eff;
}
.card div:nth-child(3) {
  padding-top: 0;
}
/deep/.el-tab-pane {
  height: 60vh;
  overflow: scroll;
}
.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-top: 10px;
}
.el-icon {
  font-size: 24px;
  color: #409eff;
  margin-top: 10px;
  vertical-align: middle;
}
</style>
